import validate from "/vercel/path0/node_modules/nuxt/dist/pages/runtime/validate.js";
import pseudo_45global from "/vercel/path0/middleware/pseudo.global.ts";
import manifest_45route_45rule from "/vercel/path0/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  pseudo_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  admin: () => import("/vercel/path0/middleware/admin.ts"),
  app: () => import("/vercel/path0/middleware/app.ts"),
  auth: () => import("/vercel/path0/middleware/auth.ts"),
  cart: () => import("/vercel/path0/middleware/cart.ts"),
  classrooms: () => import("/vercel/path0/middleware/classrooms.ts"),
  "public-demo": () => import("/vercel/path0/middleware/public-demo.ts"),
  "student-app": () => import("/vercel/path0/middleware/student-app.ts"),
  sysadmin: () => import("/vercel/path0/middleware/sysadmin.ts"),
  "write-user-permissions": () => import("/vercel/path0/middleware/write-user-permissions.ts"),
  "write-user-roles": () => import("/vercel/path0/middleware/write-user-roles.ts")
}